<template>
  <crud-form
    v-model="payload"
    page-title="Adicionar informativo"
    :request-class="requestClass"
    :total-group="3"
    navigate-back-route="contacard.informatives.list"
    navigate-page-after-save="contacard.informatives.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group title="Dados do informativo">
        <v-row>
          <v-col cols="6">
            <input-text
              v-model="payload.title"
              :rules="[requiredRule, maxLength(100)]"
              label="Título"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:Descrição"
              v-model="payload.description"
              :rules="[requiredRule, maxLength(500)]"
              label="Descrição"
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="justify-end">
          <v-col cols="6">
            <input-upload
              id="Imagem"
              v-model="image"
              :rules="[requiredRule]"
              :max-size-in-mb="5"
              required
              accept="image/jpeg, image/png"
              label="Imagem"
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
    <template slot="group-2">
      <v-divider class="mx-8" />
    </template>
    <template slot="group-3">
      <form-group title="Botão de redirecionamento">
        <v-row class="justify-end">
          <v-col cols="6">
            <v-select
              id="input:ExibirBotao"
              v-model="payload.redirectButtonVisible"
              :rules="[requiredRule]"
              :items="redirectButtonVisibleOptions"
              item-text="text"
              item-value="value"
              label="Exibir botão"
              outlined
              required
              @change="clearRedirectFields()"
            />
          </v-col>
          <v-col
            v-show="showRedirectFields"
            cols="6"
          >
            <input-text
              v-model="payload.redirectButtonText"
              :rules="[requiredButton, maxLength(30)]"
              label="Texto do botão"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row
          v-show="showRedirectFields"
        >
          <v-col cols="12">
            <input-text
              v-model="payload.redirectButtonLink"
              label="Link de redirecionamento"
              placeholder="https://example.com"
              outlined
              required
              pattern="https://.*"
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Arch/components/crud/CrudForm.vue';
import InformativesRequest from 'Modules/contacard/informatives/InformativesRequest';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';
import UploadService from 'Arch/services/UploadService';
import NotificationMixin from 'Arch/mixins/NotificationMixin';

export default {
  name: 'InformativesForm',
  components: {
    CrudForm,
    FormGroup,
  },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: InformativesRequest,
    payload: {
      id: null,
      title: '',
      description: '',
      redirectButtonText: '',
      redirectButtonLink: '',
      redirectButtonVisible: false,
      imageUrl: '',
    },
    image: {
      name: '',
      file: '',
      rawFile: null,
    },
    redirectButtonVisibleOptions: [
      { value: true, text: 'Sim' },
      { value: false, text: 'Não' },
    ],
  }),
  computed: {
    requiredButton() {
      return ((this.showRedirectFields && this.payload.redirectButtonText.length > 0)
              || !this.showRedirectFields)
              || 'Este campo é obrigatório';
    },
    showRedirectFields() {
      return (this.payload.redirectButtonVisible === true);
    },
    imageSize() {
      return (v) => (!v || v.size < 5000000) || 'O tamanho da imagem não pode exceder 5 mb.';
    },
  },
  watch: {
    'image.name': {
      immediate: true,
      handler(value) {
        if (!value) {
          this.payload.imageUrl = '';
          this.image = {
            name: '',
            file: '',
            rawFile: null,
          };
        }
      },
    },
    image: {
      deep: true,
      async handler(value) {
        this.loading = true;
        await UploadService
          .create(value)
          .then((data) => {
            this.payload.imageUrl = data.data.fileName;
          }).catch((error) => {
            this.showErrorToast({ text: error });
          }).finally(() => {
            this.loading = false;
          });
      },
    },
  },
  methods: {
    overrideSetEntityData(data) {
      this.image.name = data.imageUrl;
      return {
        id: data.id,
        title: data.title,
        description: data.description,
        redirectButtonText: data.redirectButtonText,
        redirectButtonLink: data.redirectButtonLink,
        redirectButtonVisible: data.redirectButtonVisible,
        imageUrl: data.imageUrl,
      };
    },
    overrideCreatePayload() {
      return { ...this.payload };
    },
    overrideEditPayload() {
      return { ...this.payload };
    },
    clearRedirectFields() {
      this.payload.redirectButtonText = '';
      this.payload.redirectButtonLink = '';
    },
  },
};
</script>
